<template>
  <a-card :bordered="false">
    <custom-page-list
      style="margin-top: 20px"
      :grid=" { gutter: 24, column: 6 }"
      :page-size="20"
      :load-data="loadPromise"
      ref="pageList">
      <template slot="list-item" slot-scope="row">
        <div class="item-box" @click="onItemClick(row.item)">
          <template v-if="row.item.type">
            <div class="more-title">{{ row.item.name }}</div>
            <div class="second-title">{{ row.item.secondName }}</div>
          </template>
          <template v-else>
            <div class="title">{{ row.item.name }}</div>
            <div class="second-title">{{ row.item.secondName }}</div>
          </template>
          <div class="tips">魔方云物联</div>
        </div>
      </template>
    </custom-page-list>
  </a-card>
</template>

<script>
import smartMixins from './smartMixins'
import CustomPageList from '../../../../customComponents/CustomPageList'

export default {
  name: 'DeviceManager',
  mixins: [smartMixins],

  components: { CustomPageList },
  data() {
    return {}
  },
  mounted() {
  },
  methods: {
    onItemClick(item) {
      if (item.routeName) {
        let pageParams = this.getPageParams()
        this.openNewPage(item.routeName, { ...pageParams })
      }
    },
    loadPromise() {
      return new Promise(resolve => {
        const dataList = [
          { name: '共享充电线', secondName: '(密码版)', routeName: 'ClDeviceList' },
          { name: '无人售货机', secondName: '(客房版)', routeName: 'VmDeviceList' },
          { name: '更多设备', secondName: '即将上线', type: 'more' }
        ]
        resolve({
          data: dataList,
          totalCount: dataList.length
        })
      })
    }
  }


}
</script>
<style scoped lang="less">
.item-box {
  width: 150px;
  height: 150px;
  position: relative;
  background-color: #F6F6F6;
  border-radius: 8px;

  .title {
    padding-top: 40px;
    font-size: 22px;
    font-weight: 650;
    color: #FAAD14;
    width: 100%;
    text-align: center;
  }

  .more-title {
    padding-top: 40px;
    width: 100%;
    font-size: 16px;
    text-align: center;
    font-weight: 400;
    color: #000000;
  }

  .second-title {
    padding-top: 2px;
    width: 100%;
    font-size: 16px;
    text-align: center;
    font-weight: 400;
    color: #000000;
  }

  .tips {
    position: absolute;
    bottom: 10px;
    width: 100%;
    text-align: center;
    font-size: 12px;
    color: #444444;
  }
}
</style>